import axiosInstance from './axiosInstance';

const deleteServicesConfigRate = (rateId) =>
  axiosInstance.delete(`/internal/admin/config/rates/${rateId}`);

export default deleteServicesConfigRate;
